export default __webpack_public_path__ + "static/media/3334 spice rack A top.fb728fa3.png";